import { Link } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";
import { Logo } from "./Logo";
import { useLang } from "../i18n";

export const Footer = () => {
  const { t } = useLang();

  return (
    <footer id="contact" data-testid="site-footer" className="bg-navy text-white">
      <div className="mx-auto grid max-w-7xl gap-12 px-4 py-20 sm:px-6 md:grid-cols-2 lg:grid-cols-4 lg:px-8">
        <div>
          <Logo light />
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/60">{t("footer.blurb")}</p>
        </div>

        <div>
          <h3 className="overline-label mb-5 !text-gold/90">{t("footer.dest_title")}</h3>
          <ul className="space-y-3 text-sm text-white/70">
            <li>Aéroport Nice Côte d'Azur</li>
            <li>Cannes — Croisette & Gare</li>
            <li>
              <Link to="/chauffeur-prive-mougins" data-testid="footer-mougins-link" className="transition-colors hover:text-white">
                {t("footer.mougins_link")}
              </Link>
            </li>
            <li>
              <Link to="/partenaires" data-testid="footer-partners-link" className="transition-colors hover:text-white">
                {t("footer.partners_link")}
              </Link>
            </li>
            <li>Monaco — Monte-Carlo</li>
            <li>Saint-Tropez & Pampelonne</li>
            <li>Antibes, Mougins, Grasse, Sophia Antipolis</li>
          </ul>
        </div>

        <div>
          <h3 className="overline-label mb-5 !text-gold/90">{t("footer.contact_title")}</h3>
          <ul className="space-y-3 text-sm text-white/70">
            <li>
              <a href="tel:+33661297599" data-testid="footer-phone-link" className="flex items-center gap-2 transition-colors hover:text-white">
                <Phone size={15} className="text-gold" /> +33 6 61 29 75 99
              </a>
            </li>
            <li>
              <a href="mailto:cabnow06@gmail.com" data-testid="footer-email-link" className="flex items-center gap-2 transition-colors hover:text-white">
                <Mail size={15} className="text-gold" /> cabnow06@gmail.com
              </a>
            </li>
            <li className="flex items-center gap-2">
              <MapPin size={15} className="text-gold" /> Cannes, Alpes-Maritimes
            </li>
          </ul>
        </div>

        <div>
          <h3 className="overline-label mb-5 !text-gold/90">{t("footer.avail_title")}</h3>
          <p className="text-sm text-white/70">{t("footer.avail1")}</p>
          <p className="mt-3 text-sm text-white/70">{t("footer.avail2")}</p>
          <Link
            to="/reservation"
            data-testid="footer-book-button"
            className="mt-6 inline-block rounded-full bg-azure px-6 py-3 text-sm font-bold text-white transition-[background-color,transform] hover:bg-azure-hover hover:-translate-y-0.5"
          >
            {t("footer.book")}
          </Link>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-4 py-6 text-xs text-white/40 sm:flex-row sm:px-6 lg:px-8">
          <span>{t("footer.rights")}</span>
          <span>{t("footer.legal")}</span>
        </div>
      </div>
    </footer>
  );
};
